export default "__VITE_ASSET__CYocAXyC__"